import { Component, ViewChild } from '@angular/core';
import { NgbAccordionModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Covarage from '../../../../core/data/models/covarage.model';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-coverage-modal',
    imports: [NgbAccordionModule, DecimalPipe],
    templateUrl: './coverage-modal.component.html',
    styleUrl: './coverage-modal.component.css'
})
export class CoverageModalComponent {
  @ViewChild('modal') modal!: NgbModalRef

  coverages: Covarage[] = []

  constructor(private modalService: NgbModal){}

  show(coverages: Covarage[]){
    this.coverages = coverages;
    this.modalService.open(this.modal, { size: 'lg'})
  }
}
